"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AttrbuteDataType;
(function (AttrbuteDataType) {
    AttrbuteDataType["STRING"] = "String";
    AttrbuteDataType["INT"] = "Int";
    AttrbuteDataType["DECIMAL"] = "Decimal";
    AttrbuteDataType["BOOLEAN"] = "Boolean";
    AttrbuteDataType["ACCOUNT_ADDRESS"] = "AccountAddress";
    AttrbuteDataType["HASH"] = "Hash";
    AttrbuteDataType["DATETIME"] = "DateTime";
    AttrbuteDataType["CURRENCY"] = "Currency";
})(AttrbuteDataType = exports.AttrbuteDataType || (exports.AttrbuteDataType = {}));
var AttrbuteKeyType;
(function (AttrbuteKeyType) {
    AttrbuteKeyType["PRIMARYKEY"] = "PrimaryKey";
    AttrbuteKeyType["UNIQUEKEY"] = "UniqueKey";
    AttrbuteKeyType["NONKEY"] = "NonKey";
})(AttrbuteKeyType = exports.AttrbuteKeyType || (exports.AttrbuteKeyType = {}));
//# sourceMappingURL=MetadataTypes.js.map